import { render, staticRenderFns } from "./WrittenArticles.vue?vue&type=template&id=58eb8b8e&"
import script from "./WrittenArticles.vue?vue&type=script&lang=ts&"
export * from "./WrittenArticles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports